import React from "react"
import { computeTextColor } from "./colorUtils"

interface Props {
    color: string
}

export default function OfferPreview({ color }: Props) {
    const bannerTextColor = computeTextColor(color)

    const sectionTitle = (title: string) => (
        <div
            className="tw-font-bold tw-uppercase tw-pb-1 tw-mb-1"
            style={{ color, borderBottom: `2px solid ${color}`, fontSize: 11 }}
        >
            {title}
        </div>
    )

    const line = (label: string, amount: string) => (
        <div className="tw-flex tw-flex-row tw-justify-between" style={{ fontSize: 10 }}>
            <span>{label}</span>
            <span>{amount}</span>
        </div>
    )

    return (
        <div
            className="tw-flex tw-flex-col tw-bg-white tw-rounded tw-shadow"
            style={{ width: 280, border: '1px solid #ddd', color: '#333' }}
        >
            <div
                className="tw-flex tw-flex-row tw-justify-between tw-items-center tw-px-3 tw-py-2 tw-rounded-t"
                style={{ backgroundColor: color, color: bannerTextColor }}
            >
                <span className="tw-font-bold" style={{ fontSize: 13 }}>OFFRE N° 2026-0042</span>
                <span style={{ fontSize: 10 }}>Concession</span>
            </div>
            <div className="tw-flex tw-flex-col tw-gap-3 tw-p-3">
                <div>
                    {sectionTitle('Client')}
                    {line('M. Dupont Jean', '')}
                    {line('44000 Nantes', '')}
                </div>
                <div>
                    {sectionTitle('Véhicule')}
                    {line('Modèle - Finition', '32 500,00 €')}
                    {line('Options', '1 250,00 €')}
                    {line('Remise', '- 1 500,00 €')}
                </div>
                <div
                    className="tw-flex tw-flex-row tw-justify-between tw-font-bold tw-px-2 tw-py-1 tw-rounded"
                    style={{ border: `2px solid ${color}`, color, fontSize: 12 }}
                >
                    <span>TOTAL TTC</span>
                    <span>32 250,00 €</span>
                </div>
            </div>
            <div
                className="tw-px-3 tw-py-1 tw-rounded-b tw-text-center"
                style={{ backgroundColor: color, color: bannerTextColor, fontSize: 9 }}
            >
                Concession - 1 rue de l'exemple - 44000 Nantes
            </div>
        </div>
    )
}
